// Seleção do placeholder do compositor de mensagens (FIX-MOBILE-1) da
// modernização do InfoChat.
//
// Função pura — sem JSX, sem React, sem I/O, sem leitura de
// localStorage/backend, sem acoplamento a i18n (os textos já resolvidos
// são recebidos como parâmetros). Não decide ONDE/QUANDO é chamada — só
// calcula, de forma determinística, qual texto exibir dado o estado atual.
//
// Bug corrigido: o `useEffect` anterior chamava `setPlaceHolderText` para
// o novo `ticketStatus` e, na sequência (dentro do mesmo efeito, síncrono),
// truncava usando `placeholderText` — o valor ainda antigo, capturado por
// closure da render anterior, já que a chamada a `setPlaceHolderText`
// acima é assíncrona e não atualiza a variável local imediatamente. No
// mobile (onde a truncagem é ativada), isso podia sobrescrever o texto
// novo pelo texto antigo truncado. Esta função elimina o problema pela
// raiz: não há mais estado derivado nem efeito — o placeholder é
// recalculado diretamente a cada render a partir das props atuais
// (`ticketStatus`/`isMobile`), então nunca existe um valor "antigo" para
// vazar.

const DEFAULT_MAX_LENGTH = 20;

/**
 * Seleciona o placeholder do compositor de mensagens.
 *
 * `open`/`group` usam o mesmo texto ("aberto"); `pending` preserva seu
 * próprio texto; qualquer outro status (incluindo `closed` e valores
 * desconhecidos/ausentes) usa o texto "fechado". A truncagem mobile é
 * aplicada só depois de escolher o texto do estado ATUAL — nunca ao texto
 * de um estado anterior.
 *
 * @param {object} params
 * @param {string} params.ticketStatus - status atual do ticket.
 * @param {boolean} params.isMobile - se o layout atual é mobile.
 * @param {string} params.openText - texto já resolvido para open/group.
 * @param {string} params.pendingText - texto já resolvido para pending.
 * @param {string} params.closedText - texto já resolvido para os demais.
 * @param {number} [params.maxLength] - limite de caracteres no mobile.
 * @returns {string} o placeholder final.
 */
export const selectMessageInputPlaceholder = ({
  ticketStatus,
  isMobile,
  openText,
  pendingText,
  closedText,
  maxLength = DEFAULT_MAX_LENGTH
}) => {
  const currentText =
    ticketStatus === "open" || ticketStatus === "group"
      ? openText
      : ticketStatus === "pending"
      ? pendingText
      : closedText;

  if (isMobile && typeof currentText === "string" && currentText.length > maxLength) {
    return `${currentText.substring(0, maxLength)}...`;
  }

  return currentText;
};

export default selectMessageInputPlaceholder;
